import { Button, SlideOutModal, SlideOutModalProps } from "../../../components";
import { Card } from "react-bootstrap";
import { formatPrice } from "../../../utils";

interface PaymentErrorModalProps extends SlideOutModalProps {
  error: string;
  amount: number;
  onRetry: () => void;
  onCancel: () => void;
}

export function PaymentErrorModal(props: PaymentErrorModalProps) {
  return (
    <SlideOutModal
      {...props}
      title="Payment Failed"
      footer={
        <div className="container p-0">
          <div className="row g-0">
            <div className="col-12 pe-2">
              <Button
                onClick={props.onCancel}
                variant="secondary"
                className="w-100"
              >
                Cancel
              </Button>
            </div>
            <div className="col-12 ps-2">
              <Button
                onClick={props.onRetry}
                variant="primary"
                className="w-100"
              >
                <i className="fa fa-refresh me-2"></i>
                Try Again
              </Button>
            </div>
          </div>
        </div>
      }
    >
      {/* Main Error Card */}
      <div className="text-center mb-4 py-4">
        <div className="mb-3">
          <div 
            className="d-inline-flex align-items-center justify-content-center rounded-circle" 
            style={{ 
              width: '80px', 
              height: '80px', 
              backgroundColor: '#fee', 
              border: '3px solid #dc3545' 
            }}
          >
            <i className="fa fa-times text-danger" style={{ fontSize: '40px' }}></i>
          </div>
        </div>
        <h4 className="mb-2 fw-bold text-dark">Payment Failed</h4>
        <p className="text-muted mb-0">{props.error}</p>
      </div>

      {/* Common Issues Card */}
      <Card className="shadow-sm border-0 mb-4" style={{ borderRadius: '8px', backgroundColor: '#f8f9fa' }}>
        <Card.Body className="p-3">
          <div className="d-flex align-items-start mb-3">
            <i className="fa fa-info-circle text-primary me-2 mt-1"></i>
            <div>
              <h6 className="mb-2 fw-semibold">Common Issues</h6>
              <ul className="mb-0 small text-muted ps-3">
                <li className="mb-1">Incorrect card number or security code</li>
                <li className="mb-1">Insufficient funds available</li>
                <li className="mb-1">Card has expired or been blocked</li>
                <li className="mb-0">Billing address doesn't match card records</li>
              </ul>
            </div>
          </div>
        </Card.Body>
      </Card>

      {/* Amount Due Card */}
      <Card className="shadow-sm border-0" style={{ borderRadius: '8px', backgroundColor: '#fff', border: '1px solid #dee2e6' }}>
        <Card.Body className="p-3">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <p className="mb-0 small text-muted">Payment Amount</p>
              <p className="mb-0 fw-bold fs-4">{formatPrice(props.amount)}</p>
            </div>
            <i className="fa fa-credit-card text-muted" style={{ fontSize: '24px' }}></i>
          </div>
        </Card.Body>
      </Card>
    </SlideOutModal>
  );
}